module.exports = __webpack_public_path__ + "img/symbol_13_x2.c1e4dd29.png";